import React from "react";
import { useEffect, useState } from "react";
import { getCitas } from "../../services/citaService";

const HORA_INICIO = 9;
const HORA_FIN = 22;
const PX_HORA = 60;

const HORAS = Array.from(
  { length: HORA_FIN - HORA_INICIO },
  (_, i) => HORA_INICIO + i
);

export default function VistaDiaria({
  fecha,
  profesional,
  clinica,
  refrescar,
  onSelectCita,
  onNuevaCita
}) {
  const [citas, setCitas] = useState([]);

  function obtenerColorCita(cita) {

    if (cita.profesional === "LIS") {

      if (cita.clinica === "VEN") {
        return "#86efac";
      }

      if (cita.clinica === "ELIPA") {
        return "#c084fc";
      }
    }

    return {
      ELIPA: "#59b3f8a4",
      VEN: "#fce3aeff"
    }[cita.clinica] || "#f5faff";
  }

  function agruparSolapadas(citas) {
    const grupos = [];

    citas.forEach(cita => {
      const inicio = new Date(cita.fechaInicio);
      const fin = new Date(inicio.getTime() + cita.duracionMin * 60000);

      let grupo = grupos.find(g =>
        g.some(c => {
          const i = new Date(c.fechaInicio);
          const f = new Date(i.getTime() + c.duracionMin * 60000);
          return inicio < f && fin > i;
        })
      );

      if (!grupo) {
        grupo = [];
        grupos.push(grupo);
      }

      grupo.push(cita);
    });

    return grupos;
  }

  function pintarCitasDia(citas, fechaDia, onSelect) {
    const delDia = citas.filter(c => {
      const d = new Date(c.fechaInicio);
      return d.toDateString() === fechaDia.toDateString();
    });

    const grupos = agruparSolapadas(delDia);

    return grupos.flatMap(grupo =>
      grupo.map((cita, idx) => {
        const inicio = new Date(cita.fechaInicio);

        const minutos =
          (inicio.getHours() - HORA_INICIO) * 60 +
          inicio.getMinutes();

        const top = (minutos * PX_HORA) / 60;

        const heightReal = (cita.duracionMin * PX_HORA) / 60;
        const height = Math.max(heightReal, 34);

        const width = 100 / grupo.length;

        const mostrarPaciente = true;
        const mostrarTratamiento = true;

        return (
          <div
            key={cita.id}
            className="cita cita-diaria"
            data-tooltip={`${cita.paciente}\n${cita.tratamiento}`}
            style={{
              top,
              height,
              left: `calc(${idx * width}% + 3px)`,
              width: `calc(${width}% - 6px)`,
              borderLeft: `4px solid ${cita.color || "#1890ff"}`,
              background: obtenerColorCita(cita)
            }}
            onClick={() => onSelect(cita)}
          >
            <div className="cita-contenido">
              {mostrarPaciente && <strong>{cita.paciente}</strong>}
              {mostrarTratamiento && <div>{cita.tratamiento}</div>}
            </div>
          </div>
        );
      })
    );
  }

  useEffect(() => {
    getCitas({
      clinica,
      profesional,
      from: fecha.toISOString().slice(0, 10),
      to: fecha.toISOString().slice(0, 10)
    }).then(setCitas);
  }, [fecha, clinica, profesional, refrescar]);

  const ahora = new Date();
  const esHoy = ahora.toDateString() === fecha.toDateString();

  const minutosDesdeInicio =
    (ahora.getHours() - HORA_INICIO) * 60 +
    ahora.getMinutes();

  const topHoraActual = (minutosDesdeInicio * PX_HORA) / 60;

  const citasFiltradas = citas;

  return (
    <div className="agenda">
      <div className="agenda-grid">

        <div className="agenda-header">
          <div className="hora-col-header"></div>

          <div className="dia-header dia-header-diaria">
            Hoy
          </div>
        </div>

        <div className="agenda-body">

          <div className="hora-col">
            {HORAS.map(h => (
              <div
                key={h}
                className={`hora-label ${
                  esHoy && h === ahora.getHours()
                    ? "hora-actual"
                    : ""
                }`}
              >
                {h}:00
              </div>
            ))}
          </div>

          <div className="dias-grid diaria">
            <div className="dia-col">

              {HORAS.map(h => (
                <div
                  key={h}
                  className="celda-hora"
                  onClick={() => onNuevaCita(fecha, h)}
                />
              ))}

              {esHoy && (
                <div
                  className="linea-hora-actual"
                  style={{ top: topHoraActual }}
                />
              )}

              {pintarCitasDia(
                citasFiltradas,
                fecha,
                onSelectCita
              )}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}